import '../../../styles/main.scss';
import './index.scss';

// import '../../../components/card';
// import '../../../components/button';
// import '../../../components/link';

// React Common imports 
import React from 'react';
import { createRoot } from 'react-dom/client';

//Components
import { Section } from '../../../react-components/layout/section';
import { SectionAbout } from '../../../react-components/layout/sections/about';
import { SectionHero } from '../../../react-components/layout/sections/hero';
import { SectionFeatures } from '../../../react-components/layout/sections/features';
// import { SectionAbout, SectionHero, SectionFeatures }  from '../../../react-components/layout/';

import { Button } from '../../../react-components/components/button';
import { Header } from '../../../react-components/layout/header';


const app = document.getElementById("app");
app.innerHTML = '';
const root = createRoot(app);

root.render(
  <>
    <div className='background'>
      <div className='circle1'></div>
      <div className='circle2'></div>
      <div className='circle3'></div>
    </div>
    
    <Header className='header' />
    <div className='main'>
      
      <Section name='hero'>
        <SectionHero />
      </Section>

      <Section name='features'>
        <SectionFeatures />
      </Section>

      <Section name='about'>
        <SectionAbout />
      </Section>

    </div>
  </>
)


